import { render, staticRenderFns } from "./edit-Swiper.vue?vue&type=template&id=492c8648"
import script from "./edit-Swiper.vue?vue&type=script&lang=ts"
export * from "./edit-Swiper.vue?vue&type=script&lang=ts"
import style0 from "./edit-Swiper.vue?vue&type=style&index=0&id=492c8648&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports